import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  shake?: boolean;  // New prop to control shake animation
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, shake = false }) => {
  if (!isOpen) return null;

  return (
    <div className="modal" onClick={onClose}>
      <div className={`modal-content ${shake ? 'shake' : ''}`} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};